// extracted by mini-css-extract-plugin
export default {"mainWrapper":"InviteBoard_mainWrapper__Pbgji","formLogin":"InviteBoard_formLogin__+CNeP"};